exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav.nav-pills[data-v-7f5f4f46]{margin:-.25rem}.nav.nav-pills .nav-link[data-v-7f5f4f46]{margin:.25rem}", ""]);

// exports
